import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {CountryService} from '../../../../../services/country/country.service';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import { NgOptimizedImage } from '@angular/common';
import {ParisDatePipe} from '../../../../../pipes/date/paris-date.pipe';
import {Lead} from '../../../../../models/lead';
import {MoneyPipe} from '../../../../../pipes/money/money.pipe';
import {LoaderService} from '../../../../../services/loader/loader.service';
import {LeadService} from '../../../../../services/lead/lead.service';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';

@Component({
  selector: 'app-lead-detail',
  imports: [
    ParisDatePipe,
    NgOptimizedImage,
    MoneyPipe,
    IsGrantedDirective
],
  templateUrl: './lead-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lead-detail.component.scss'
})
export class LeadDetailComponent implements Dialog {
  lead: Lead | null = null;

  constructor(
    private loader: LoaderService,
    protected leadService: LeadService,
    protected countryService: CountryService,
  ) {
  }

  onDialogInit(params: DialogParams): void {
    params.visible = false;
    this.loader.startLoading();
    this.leadService.findOneById(params.data.id, {
      groups: 'product,offer,landingPage,partner'
    }).subscribe(lead => {
      this.lead = lead;
      this.loader.stopLoading();
      params.visible = true;
    });
  }

  getLeadUpResponse(lead: Lead): string {
    try {
      const data = JSON.parse(lead?.leadUpResponse ?? '');
      return JSON.stringify(data, null, 2);
    } catch (e) {
      return '';
    }
  }

  getSourceDetails(lead: Lead): string {
    return JSON.stringify(lead?.sourceDetails, null, 2);
  }

  /**
   * The API nulls the fingerprint when ROLE_API_FINGERPRINT_VIEW is missing: showing
   * an empty row would read as "no fingerprint collected" instead of "not allowed".
   */
  hasFingerprint(lead: Lead): boolean {
    return !!lead?.fingerprint && Object.keys(lead.fingerprint).length > 0;
  }

  getFingerprint(lead: Lead): string {
    return JSON.stringify(lead?.fingerprint, null, 2);
  }
}
